
var data = {
    SERVER_URL: "https://examprepback.educare.school/api/v1/",
    // SERVER_URL: "http://localhost:3001/api/v1/",
};




module.exports = data;
